/*
 * @Author: Fan
 * @Date: 2020-04-13 17:06:58
 * @LastEditTime: 2020-07-06 18:13:20
 * @LastEditors: zhuqiu
 * @Description:
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\RelevanceForm\conduct.ts
 */
import { listApi } from "../../../../api";
import { DataItemType } from "../../../../form/schema";
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterRequiredFormula, formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控件属性",
            keys: [
                "selectMode",
                "showField",
                "isAuthorize",
                "defaultVal",
                "isScan",
                "dataLinkage"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.RelevanceForm').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.RelevanceForm').toString() }),
        // 筛选条件
        searchFormula: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/relevance-form-search-formula.vue"),
            options: {
                importModal: (attr, attrs) => {
                    const queryCodeAttr = attrs.find((a) => a.field === "queryCode");
                    const queryCode = queryCodeAttr ? queryCodeAttr.value : "";
                    const schemaObj = attrs.find((a) => a.field === "schemaCode");
                    const schemaCode = schemaObj ? schemaObj.value : "";
                    // const query = attrs.find((a: any) => a.field === "conditions").value;
                    return {
                        schemaCode,
                        queryCode,
                        dataItem: queryCodeAttr.dataItem,
                        type: "mapping",
                        value: {
                            query: attr.value,
                        },
                    };
                },
                formatter: formatterValueToSetStatus,
            },
        },
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        // 只读条件
        readonlyCondition: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "readonlyCondition",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        schemaCode: {
            inputMethod: ControlAttributeType.Tree,
            options: {
                formatter: formatterRequiredFormula,
                hideField: (value) => {
                    return !value ? ["queryCode"] : [];
                },
                callback: (key, attr, attrs, vm) => {
                    vm.updateAttribute(key, "queryCode", "");
                    vm.updateAttribute(key, "displayField", "name");
                    vm.updateAttribute(key, "conditions", "");
                    vm.updateAttribute(key, "mappings", "");
                },
            },
        },
        queryCode: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                dataList: (attr, attrs, vm) => {
                    let appCode = vm.$route.params.appCode; // 集成组要求 加入当前应用code
                    const attrItem = attrs.find((a) => a.field === "schemaCode");
                    let schemaCode = attrItem ? attrItem.value : '';
                    //未获取到关联表单的编码则获取option中的schemaCode
                    if (!schemaCode && attrItem.dataItem) {
                        let optionsJson = attrItem.dataItem.options ? JSON.parse(attrItem.dataItem.options) : '';
                        schemaCode = optionsJson ? optionsJson.schemaCode : '';
                    }
                    if (schemaCode) {
                        return listApi.getListConfigList(schemaCode, undefined, appCode).then((res) => {
                            if (res.errcode === 0) {
                                let d = res.data
                                    .filter((l) => l.publish)
                                    .map((x) => ({
                                    value: x.code,
                                    label: x.name,
                                }));
                                // if (d.length && !attr.value) {
                                //   attr.value = d[0].value;
                                // }
                                return d;
                            }
                            return [];
                        }, () => Promise.resolve([]));
                    }
                    else {
                        return Promise.resolve([]);
                    }
                },
                hideField: (value) => {
                    return !value ? ["conditions"] : [];
                },
                callback: (key, attr, attrs, vm) => {
                    vm.updateAttribute(key, "conditions", "");
                },
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        displayField: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                dataList(attr, attrs) {
                    const attrItem = attrs.find((a) => a.field === "schemaCode");
                    let schemaCode = attrItem ? attrItem.value : '';
                    //未获取到关联表单的编码则获取option中的schemaCode
                    if (!schemaCode && attrItem.dataItem) {
                        let optionsJson = attrItem.dataItem.options ? JSON.parse(attrItem.dataItem.options) : '';
                        schemaCode = optionsJson ? optionsJson.schemaCode : '';
                    }
                    let { dataItem } = attr;
                    if (dataItem && dataItem.relativePropertyCode &&
                        attr.value !== dataItem.relativePropertyCode) {
                        attr.value = dataItem.relativePropertyCode;
                    }
                    if (schemaCode) {
                        return listApi
                            .getDataItemList({
                            schemaCode,
                            isPublish: true,
                        })
                            .then((res) => {
                            let isDefault = false;
                            if (res.errcode === 0) {
                                let d = [];
                                let ignoreDateItem = [
                                    DataItemType.Attachment,
                                    DataItemType.Sheet,
                                    DataItemType.RelevanceForm,
                                    DataItemType.RelevanceFormEx,
                                ];
                                for (let item of res.data) {
                                    if (!~ignoreDateItem.indexOf(item.propertyType) &&
                                        item.code !== "ownerDeptQueryCode") {
                                        d.push({
                                            value: item.code,
                                            label: item.name,
                                        });
                                    }
                                    // 判断关联的显示字段是否被删除
                                    if (item.code === attr.value) {
                                        isDefault = true;
                                    }
                                }
                                if (!isDefault)
                                    attr.value = "name";
                                if (!attr.value)
                                    attr.value = "name";
                                if (d.length === 0) {
                                    d.push({
                                        label: i18n.t('dataitem.DataTitle').toString(),
                                        value: "name",
                                    });
                                }
                                return d;
                            }
                            return [];
                        }, () => {
                            attr.value = "";
                            return Promise.resolve([]);
                        });
                    }
                    else {
                        attr.value = "";
                        return Promise.resolve([]);
                    }
                },
            },
        },
        mappings: {
            modalType: "mapping",
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/relevance-selection-map2.vue"),
            options: {
                importModal: (attr, attrs, extraAttrs) => {
                    let queryCodeAttr = attrs.find((a) => a.field === "queryCode");
                    if (!queryCodeAttr && Array.isArray(extraAttrs)) {
                        queryCodeAttr = extraAttrs.find((a) => a.field === "queryCode");
                    }
                    let queryCode = queryCodeAttr ? queryCodeAttr.value : null;
                    let schemaCodeAttr = attrs.find((a) => a.field === "schemaCode");
                    if (!schemaCodeAttr && Array.isArray(extraAttrs)) {
                        schemaCodeAttr = extraAttrs.find((a) => a.field === "schemaCode");
                    }
                    let schemaCode = schemaCodeAttr ? schemaCodeAttr.value : null;
                    return {
                        schemaCode,
                        queryCode,
                        dataItem: queryCodeAttr ? queryCodeAttr.dataItem : null,
                        value: attr.value,
                    };
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    vm.$emit("change", "mappings", data.value); //改变属性需要提交
                    //
                    return data.value;
                },
                formatter: formatterValueToSetStatus,
            },
        },
        conditions: {
            modalType: "query",
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/query-condition.vue"),
            options: {
                importModal: (attr, attrs) => {
                    const queryCodeAttr = attrs.find((a) => a.field === "queryCode");
                    const queryCode = queryCodeAttr.value;
                    const schemaCode = attrs.find((a) => a.field === "schemaCode")
                        .value;
                    return {
                        schemaCode,
                        queryCode,
                        dataItem: queryCodeAttr.dataItem,
                        type: "query",
                        value: {
                            query: attr.value,
                        },
                    };
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    // vm.$emit("change", "mappings", data.value.mapping); //改变属性需要提交
                    //
                    return data.value.query;
                },
                formatter: formatterValueToSetStatus,
            },
        },
        mobileConditions: {
            modalType: "onlyQuery",
            clientType: "APP",
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/query-condition.vue"),
            options: {
                importModal: (attr, attrs) => {
                    const queryCodeAttr = attrs.find((a) => a.field === "queryCode");
                    const queryCode = queryCodeAttr.value;
                    const schemaCode = attrs.find((a) => a.field === "schemaCode")
                        .value;
                    return {
                        schemaCode,
                        queryCode,
                        dataItem: queryCodeAttr.dataItem,
                        type: "onlyQuery",
                        clientType: "APP",
                        value: {
                            query: attr.value,
                        },
                    };
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    return data.value.query;
                },
                formatter: formatterValueToSetStatus,
            },
        },
        showStyle: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "list",
            options: {
                list: [
                    {
                        value: "list",
                        label: i18n.t('dataitem.List').toString(),
                    },
                    {
                        value: "tree",
                        label: i18n.t('dataitem.Tree').toString(),
                    },
                ],
            },
        },
        selectMode: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "popup",
            options: {
                hideField: (value) => {
                    return value === "dropdown" ? ["showField"] : [];
                },
                list: [
                    {
                        value: "popup",
                        label: i18n.t('dataitem.PopupModal').toString(),
                    },
                    {
                        value: "dropdown",
                        label: i18n.t('dataitem.DropdownInput').toString(),
                    },
                ],
                callback: (key, attr, attrs, vm) => {
                    const attrItem = attrs.find((a) => a.field === "showField");
                    const showField = attrItem ? attrItem.value : '';
                    vm.updateAttribute(key, "showField", showField && showField.length > 0
                        ? showField
                        : []);
                },
            },
        },
        showField: {
            value: [],
            type: ControlAttributeType.Array,
            options: {
                dataList(attr, attrs) {
                    // const attrItem = attrs.find((a: any) => a.field === "schemaCode");
                    // const schemaCode = attrItem ? attrItem.value : '';
                    let schemaCode = attr.dataItem.relativeCode;
                    //未获取到关联表单的编码则获取option中的schemaCode
                    if (!schemaCode && attr.dataItem) {
                        let optionsJson = attr.dataItem.options ? JSON.parse(attr.dataItem.options) : '';
                        schemaCode = optionsJson ? optionsJson.schemaCode : '';
                    }
                    if (schemaCode) {
                        return listApi
                            .getDataItemList({
                            schemaCode,
                            isPublish: true,
                        })
                            .then((res) => {
                            if (res.errcode === 0) {
                                let queryCopy = res.data
                                    ? JSON.parse(JSON.stringify(res.data))
                                    : [];
                                return queryCopy
                                    .map((x, i) => x)
                                    .filter((x, i) => {
                                    const ignoreType = [1, 6, 7, 8]; // type代表控件类型: 屏蔽长文本、附件、审批意见、子表
                                    return !ignoreType.includes(x.type);
                                });
                            }
                            return [];
                        }, () => {
                            attr.value = "";
                            return Promise.resolve([]);
                        });
                    }
                    else {
                        attr.value = "";
                        return Promise.resolve([]);
                    }
                },
            },
            label: i18n.t('dataitem.PopupField').toString(),
        },
        defaultVal: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/relevance-form-default-value.vue"),
            options: {
                importModal: (attr, attrs, extraArr) => {
                    const queryCodeAttr = extraArr.find((a) => a.field === "queryCode");
                    const queryCode = queryCodeAttr.value;
                    let schemaCodeAttr = extraArr.find((a) => a.field === "schemaCode");
                    const schemaCode = schemaCodeAttr.value;
                    // const query = attrs.find((a: any) => a.field === "conditions").value;
                    return {
                        schemaCode,
                        queryCode,
                        dataItem: queryCodeAttr.dataItem,
                        type: "mapping",
                        value: {
                            query: attr.value,
                        },
                    };
                },
                formatter: formatterValueToSetStatus,
            },
        },
        isAuthorize: {
            inputMethod: ControlAttributeType.Dropdown,
            value: true,
            options: {
                list: [
                    {
                        value: false,
                        label: i18n.t('dataitem.No').toString(),
                    },
                    {
                        value: true,
                        label: i18n.t('dataitem.Readable').toString(),
                    },
                    {
                        value: "Optional",
                        label: i18n.t('dataitem.Selectable').toString(),
                    },
                ]
            },
        },
    },
};
